

const InfopersonReducer = (state, action) => {
    switch (action.type) {
        case "GET_INFOPERSON_START":
            return {
                ...state,
                infoperson: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_INFOPERSON_SUCCESS":
            return {
                ...state,
                infoperson: action.payload.user,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_INFOPERSON_FAILURE":
            return {
                ...state,
                infoperson: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "UPDATE_INFOPERSON_START":
            return {
                ...state,
                message: "",
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_INFOPERSON_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_INFOPERSON_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "CARTE_IMAGE_START":
            return {
                ...state,
                message: "",
                isFetchingDelete: true,
                errorDelete: false,
            };
        case "CARTE_IMAGE_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingDelete: false,
                errorDelete: false,
            };
        case "CARTE_IMAGE_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingDelete: false,
                errorDelete: action.payload,
            };
        case "CLEAR_INFOPERSON":
            return {
                ...state,
                message: "",
                infoperson: {},
            };
        case "CLEAR_FETCH_ERROR":
            return {
                ...state,
                message: "",
                isFetchingGet: false,
                isFetchingUpdate: false,
                errorGet: false,
                errorUpdate: false,
            };
        default:
            return { ...state };
    }
}

export default InfopersonReducer;